<template>
  <el-form label-width="120px">
    <el-form-item
      label="Manufacturer"
      required
    >
      <el-select
        v-model="selectedManufacturer"
        class="w-100"
        clearable
        value-key="id"
        :loading="isLoadingManufacturers"
        @change="() => { asset.manufacturer_model = undefined }"
      >
        <el-option
          v-for="manufacturer in manufacturers"
          :key="manufacturer.id"
          :label="manufacturer.label"
          :value="manufacturer"
        />
      </el-select>
    </el-form-item>

    <el-form-item
      label="Model"
      required
    >
      <el-select
        v-model="asset.manufacturer_model"
        class="w-100"
        value-key="id"
        :loading="isLoadingManufacturerModels"
        :disabled="!selectedManufacturer"
      >
        <el-option
          v-for="manufacturerModel in manufacturerModels"
          :key="manufacturerModel.id"
          :label="manufacturerModel.label"
          :value="manufacturerModel"
        />
      </el-select>
    </el-form-item>

    <el-form-item
      label="Serial Number"
      required
    >
      <el-input
        v-model="asset.serial"
        class="w-100"
      />
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoadingManufacturers: false,
      isLoadingManufacturerModels: false,
      manufacturers: [],
      manufacturerModels: [],
      selectedManufacturer: undefined
    }
  },
  watch: {
    selectedManufacturer (manufacturer) {
      if (manufacturer.models.length > 0) {
        this.manufacturerModels = manufacturer.models
      } else {
        this.loadManufacturerModels()
      }
    }
  },
  mounted () {
    this.loadManufacturers()
  },
  methods: {
    async loadManufacturers () {
      this.isLoadingManufacturers = true

      try {
        this.manufacturers = await this
          .$sdk
          .assetmanufacturer
          .list(request => {
            request.include = [ 'models' ]
            request.limit = 100
          })

        if (this.asset.manufacturer_model && this.asset.manufacturer_model.asset_manufacturer) {
          this.selectedManufacturer = this.asset.manufacturer_model.asset_manufacturer
        }
      } finally {
        this.isLoadingManufacturers = false
      }
    },
    async loadManufacturerModels () {
      this.isLoadingManufacturerModels = true

      try {
        this.manufacturerModels = await this
          .$sdk
          .assetmanufacturer_model
          .list(request => {
            request.context = { resource: 'assetmanufacturer', identifier: this.selectedManufacturer.id }
            request.limit = 100
          })
      } finally {
        this.isLoadingManufacturerModels = false
      }
    }
  }
}
</script>
